import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PosterPrints = () => {

  const  servicesFaqData = [
    { 
        question: "What are poster prints, and where can they be used?", 
        answer: "Poster prints are high-quality visual displays for advertising, decor, and branding. They are ideal for retail stores, events, offices, and public spaces where impactful messaging is required. Posters can promote sales, highlight brand identity, or enhance interiors with decorative artwork. With various sizes and customisation options, poster prints are versatile tools for communication and engagement. Their affordability and effectiveness make them suitable for both professional and personal applications."
    },
    { 
        question: "What are the benefits of custom poster printing? ", 
        answer: "Custom poster printing allows businesses to create tailored designs that reflect their brand, message, or promotional goals. Customisation ensures the posters align with your branding and stand out in any environment. High-resolution printing ensures sharp visuals and vibrant colours, effectively capturing attention. Custom posters can be used in multiple settings, from wall displays to promotional campaigns, enhancing versatility. Additionally, the ability to choose materials and finishes ensures that your posters are durable and suitable for specific needs."
    },
    { 
        question: "Can Printingy handle bulk orders for poster prints? ", 
        answer: "Printingy specialises in Bulk Poster Printing, providing cost-effective solutions for large-scale orders. Bulk printing reduces per-unit costs, making it an economical choice for businesses requiring multiple posters for promotions, events, or retail campaigns. Our advanced printing technology ensures consistent quality across all prints, regardless of the order size. We also offer quick turnaround times, ensuring that large orders are delivered on schedule. Whether for a one-time event or ongoing branding efforts, Printingy is equipped to handle your bulk printing needs."
    },
    { 
        question: "What materials are used for personalised poster printing? ", 
        answer: "Our Personalised Printing services use premium materials such as photo paper, canvas, or vinyl to meet diverse needs. Photo paper is ideal for vibrant, detailed visuals, making it perfect for indoor displays. Canvas provides a textured, artistic look, adding sophistication to decorative or branding posters. Vinyl materials are durable and water-resistant, suitable for outdoor use and long-term displays. Each material is selected based on the specific requirements of your project, ensuring a professional finish and lasting appeal."
    },
    { 
        question: "What industries benefit from poster printing services? ", 
        answer: "Retail, entertainment, education, and hospitality industries benefit significantly from poster printing services. Retailers use posters for in-store promotions and window displays. Entertainment venues rely on them for advertising events, concerts, or films. Educational institutions use posters for campus events, promotional campaigns, and learning materials. Hospitality businesses leverage poster prints for menu boards, seasonal promotions, and decorative elements. The versatility and affordability of posters make them an essential tool for communication and branding across various industries."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing of Poster Prints');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Custom Poster Printing Services for Walls and Promotions"
  description="High-quality printing of poster prints for walls and events. Bulk custom poster printing, personalised printing, and professional poster printing solutions."
  keywords="Printing of Poster Prints,
Poster Printing for Wall,
Custom Posters Printing,
Personalised Printing,
Bulk Poster Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Poster Prints </h1>
              <h2 className="text-muted">Custom posters for walls, promotions, and branding campaigns </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Posters are a versatile and impactful way to communicate messages, promote brands, and enhance decor. Printingy specialises in printing Poster Prints, offering high-quality Poster Printing for Wall displays, events, and retail promotions.</p>
          <p>Our services include Custom Posters Printing for tailored branding needs, allowing you to create unique designs that align with your business goals. We also provide Personalised Printing solutions for individual or corporate requirements that make your posters stand out. With our Bulk Poster Printing, you can efficiently scale your advertising or branding campaigns with cost-effective solutions.</p>
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Poster Printing Solutions </h2>
                <h3 className="large-hed">High-quality, vibrant, and versatile posters for all needs  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert printing of Poster Prints for impactful visuals. 
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk poster printing for wall displays with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised Custom Posters Printing for unique branding.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional Personalised Printing services with premium materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and fade-resistant posters for long-term use.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Multiple size options suitable for various display needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for businesses, event organisers, and retail promotions.

                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/posterprints.jpg" // Path relative to the public folder
                  alt="Professional printing of poster prints services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Poster Prints Delivered On Time </h2>
            <h3 className="small-hed">Focus on your promotions while we manage your poster printing needs </h3>
            <p>At Printingy, we deliver exceptional Poster Printing for walls and promotional displays using advanced technology and premium materials. Our Custom Posters Printing services ensure precision and vibrant results, whether for corporate branding, retail promotions, or decorative purposes.</p>
            <p>We prioritise quality and efficiency, guaranteeing timely delivery for bulk orders and customised projects. Partner with Printingy for reliable and professional poster printing that enhances your campaigns.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PosterPrints;
